import React, {useEffect, useState} from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import ResetPasswordForm from "../ResetPasswordForm";
import RoleSelector from "./RoleSelector";
import {useSelector} from "react-redux";
import {QRCodeCanvas} from "qrcode.react";

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showResetForm, setResetForm] = useState(false);
    const [showRoleSelection, setRoleSelection] = useState(false);
    const [showAuthenticator, setShowAuthenticator] = useState(false);
    const [authenticatorCode, setAuthenticatorCode] = useState('');
    const navigate = useNavigate();
    const { handleLogin } = useAuth();
    const { authToken, userGroups } = useAuth();
    const authenticatorEnabled = useSelector((state) => state.authentication.authenticator.enabled);
    const provisioningURI = useSelector((state) => state.authentication.authenticator.provisioningURI);

    useEffect(() => {
        if (authToken && userGroups) {
            if (userGroups.length > 1 && !localStorage.getItem("selectedRole")) {
                setShowAuthenticator(false);
                setRoleSelection(true);
            } else {
                if (userGroups.includes('staffmembers')) {
                    navigate('/mdb/staff');
                } else if (userGroups.includes('humanressource')) {
                    navigate('/mdb/hr');
                } else if (
                    userGroups.includes('institute') ||
                    userGroups.includes('assistant')
                ) {
                    navigate('/mdb/institute');
                } else if (userGroups.includes('rectorate')) {
                    navigate('/mdb/rectorate');
                } else if (userGroups.includes('school')) {
                    navigate('/mdb/school');
                } else if (userGroups.includes('federalstate')) {
                    navigate('/mdb/federalstate');
                } else if (userGroups.includes('admin')) {
                    navigate('/mdb/admin');
                }
            }
        }
        if (authenticatorEnabled) {
            setShowAuthenticator(true);
        }
    }, [navigate, authToken, userGroups, authenticatorEnabled, setShowAuthenticator]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        await handleLogin({ email, password, authenticatorCode });
    };

    return (
        <div>
        { !showResetForm && !showRoleSelection && !showAuthenticator && (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="E-Mail"
                        className="form-control"
                        id="email"
                        value={email} // Stellen Sie sicher, dass value auf den Zustand verweist
                        onChange={(e) => setEmail(e.target.value)} // Aktualisieren Sie den Zustand bei Änderung
                    />
                </div>
                <div className="form-group py-2">
                    <input
                        type="password"
                        placeholder="Passwort (für @phwien.ac.at - PH Online Passwort verwenden)"
                        className="form-control"
                        id="password"
                        value={password} // Stellen Sie sicher, dass value auf den Zustand verweist
                        onChange={(e) => setPassword(e.target.value)} // Aktualisieren Sie den Zustand bei Änderung
                    />
                </div>
                <div className="mb-2 py-2 text-end">
                    <button type="button" className="btn btn-link" onClick={() => setResetForm(true)}>Passwort vergessen?</button>
                    <button type="submit" className="btn btn-primary">Einloggen</button>
                </div>
            </form>
        )}
        { showResetForm && !showRoleSelection && (
            <ResetPasswordForm setResetForm={setResetForm} />
        )}
        { showAuthenticator && (
            <>
                <div>
                    <h3>Authenticator</h3>
                    Bitte authentifizieren Sie sich mit Ihrem Authenticator.
                </div>
                {provisioningURI && (<QRCodeCanvas value={provisioningURI}  />)}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Authentifikationscode"
                            className="form-control"
                            id="authCode"
                            onChange={(e) => setAuthenticatorCode(e.target.value)} // Aktualisieren Sie den Zustand bei Änderung
                        />
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary mt-2">
                            Authentifizieren
                        </button>
                    </div>
                </form>
            </>
        )}
        { !showAuthenticator && showRoleSelection  && (
            <RoleSelector userGroups={userGroups} />
        )}
        </div>

    );
};

export default LoginForm;
